import { render, staticRenderFns } from "./AdminSettingsForm.vue?vue&type=template&id=c4f05a18&scoped=true"
import script from "./AdminSettingsForm.vue?vue&type=script&lang=ts"
export * from "./AdminSettingsForm.vue?vue&type=script&lang=ts"
import style0 from "./AdminSettingsForm.vue?vue&type=style&index=0&id=c4f05a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f05a18",
  null
  
)

export default component.exports